@if (!readonly) {
  <cap-content-header [disableBreadcrumb]="true">
    <cap-title>
      {{ "datenexport.stapelverarbeitungsauftragErstellen" | translate }}
    </cap-title>
  </cap-content-header>
}

<cap-wizard [linear]="true" [readonly]="readonly">
  <cdk-step [editable]="true" [optional]="false" label="{{ 'datenexport.auswahlAuftragstyp' + (readonly ? '_readonly' : '') | translate }}">
    <ng-template cdkStepLabel>
      <span>{{ "datenexport.auswahlAuftragstyp" + (readonly ? "_readonly" : "") | translate }}</span>
    </ng-template>
    <cap-select-auftragstyp [(template)]="currentTemplateSelected" [readonly]="readonly"></cap-select-auftragstyp>
  </cdk-step>

  <cdk-step
    (interacted)="popAllAlerts()"
    [editable]="true"
    [optional]="false"
    label="{{ 'datenexport.auswahlBetroffenerDatenbestand' + (readonly ? '_readonly' : '') | translate }}">
    <ng-template cdkStepLabel>
      <span>{{ "datenexport.auswahlBetroffenerDatenbestand" + (readonly ? "_readonly" : "") | translate }}</span>
    </ng-template>
    @if (currentTemplateSelected) {
      <cap-select-auftragsbestand
        [disabled]="readonly || (currentTemplateSelected.model && !currentTemplateSelected.model.selektionskriterienVeraenderbar)"
        [readonly]="readonly"
        [template]="currentTemplateSelected.model && currentTemplateSelected.model.selektionskriterien"
        [wizard]="wizard">
      </cap-select-auftragsbestand>
    }
  </cdk-step>

  <cdk-step
    (interacted)="popAllAlerts()"
    [editable]="true"
    [optional]="false"
    label="{{ 'datenexport.auswahlErgebnisoptionen' + (readonly ? '_readonly' : '') | translate }}">
    <ng-template cdkStepLabel>
      <span>{{ "datenexport.auswahlErgebnisoptionen" + (readonly ? "_readonly" : "") | translate }}</span>
    </ng-template>
    <cap-select-auftragsexportkriterien [readonly]="readonly" [template]="currentTemplateSelected" [wizard]="wizard">
    </cap-select-auftragsexportkriterien>
  </cdk-step>

  <cdk-step
    [editable]="true"
    [optional]="false"
    label="{{ 'datenexport.auswahlAuftragsoptionen' + (readonly ? '_readonly' : '') | translate }}">
    <ng-template cdkStepLabel>
      <span>{{ "datenexport.auswahlAuftragsoptionen" + (readonly ? "_readonly" : "") | translate }}</span>
    </ng-template>
    <cap-select-auftragsoptionen
      [auftrag]="auftrag"
      [readonly]="readonly"
      [template]="currentTemplateSelected"></cap-select-auftragsoptionen>
  </cdk-step>
</cap-wizard>
